import { render, staticRenderFns } from "./LobbyStatus.vue?vue&type=template&id=27ec1184"
import script from "./LobbyStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./LobbyStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LobbyStatus.vue?vue&type=style&index=0&id=27ec1184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports